// extracted by mini-css-extract-plugin
module.exports = {"toolbarSpacing":"styles__toolbarSpacing___1H5rg"};